import { RadioGroup } from '@mui/material';
import styled from 'styled-components';

export const ApplicationContainerStyled = styled('div')({
  alignItems: 'center',
  backgroundColor: '#ffffff',
  boxShadow: '0px 1px 10px 0px #0000003D',
  padding: '40px 36px',
  marginBottom: '16px',
  '@media screen and (max-width: 743px)': {
    padding: '24px 16px',
    flexDirection: 'column',
    height: 'auto',
  },
});

export const RadioGroupStyled = styled(RadioGroup)({
  alignItems: 'left',
  textAlign: 'left',
  paddingLeft: '16px',
  marginTop: '16px',
  paddingBottom: '16px',
  borderBottom: '1px solid #E6E6E6',
});

export const PPPWrapper = styled('div')({
  minHeight: '52px',
});

export const BorderStyled = styled('div')({
  '@media screen and (min-width: 744px)': {
    borderBottom: '1px solid #E6E6E6',
  },
});

export const CoverageNumbersStyled = styled('div')({
  borderRadius: '4px',
  border: '1px solid var(--neutral-grey-400, #707178)',
  marginTop: '4px',
  boxShadow: '0 1px 10px 0 rgba(0, 0, 0, 0.24)',
  maxHeight: '400px',
  overflowY: 'scroll',
  backgroundColor: 'var(--neutral-white, #ffffff)',
  zIndex: '4',
  position: 'absolute',
  width: 'calc(100% - 95px)',
  '@media screen and (max-width: 744px)': {
    width: '350px',
  },
  '#approval': {
    borderTop: 'solid 1px var(--neutral-grey-400, #707178)',
  },
});
